import React, { Component } from 'react';
import { CancelLink } from '@/features/subscription/components/subcomponents/CancelLink';
import { Button } from '@trevor/ui-components';
import { post } from '@/util/helpers/ajax-helpers';
import css from '../../css/module/billing.css';
import flex from '../../css/module/flex.css';
import ModalContent from '../ModalContent';

class ChangePlan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      saving: false,
      plan: this.props.existingPlan.id,
    };
    this.updatePlan = this.updatePlan.bind(this);
    this.save = this.save.bind(this);
  }

  save() {
    const { isPayingCustomer, closeModal, onSaveForNewCustomers } = this.props;

    if (!isPayingCustomer) {
      onSaveForNewCustomers(this.state.plan);
      closeModal();
      return;
    }
    this.setState({
      saving: true,
    });
    post('updating active plan', '/api/subscription/plan', {
      newPlan: this.state.plan,
    }).then((json) => {
      this.props.onUpdated(json.updateDate, json.success);
    });
  }

  updatePlan(plan) {
    this.setState({
      plan,
    });
  }

  content() {
    const { plans, formatPrice, showCoupon } = this.props;
    return plans.map((plan, i) => {
      const name = plan.title;

      const selectedClass =
        this.state.plan === plan.id ? css.selectedClass : '';

      return (
        <div
          key={i}
          onClick={() => this.updatePlan(plan.id)}
          className={`${css.planOption} ${selectedClass} ${flex.justifyContentBetween}`}
        >
          <span>
            <b>{name}</b>
            <br />
            {showCoupon ? (
              <em>
                {plan.isTiredAmount ? 'from ' : null}
                <span className="strike-through">
                  {formatPrice(plan.id, false)} / month
                </span>
                &nbsp;
                <span>{formatPrice(plan.id, true)} / month</span>
              </em>
            ) : (
              <em>
                {plan.isTiredAmount ? 'from ' : null}
                {formatPrice(plan.id, false)} / month
              </em>
            )}
          </span>
          {this.state.plan === plan.id ? (
            'Selected'
          ) : (
            <Button
              variant="secondary"
              size="small"
              style={{ marginTop: '-2px' }}
            >
              Select plan
            </Button>
          )}
        </div>
      );
    });
  }

  render() {
    const { plans, closeModal, existingPlan, isPayingCustomer, navigate } =
      this.props;

    // if the user's existing plan is not one of the plans in the list, selectedPlan will be undefined.
    const selectedPlan = plans.find((plan) => plan.id === this.state.plan);

    const saveText =
      isPayingCustomer && selectedPlan && selectedPlan.id !== existingPlan.id
        ? selectedPlan.startingPrice < existingPlan.startingPrice
          ? 'Switch plan upon renewal'
          : 'Upgrade now'
        : 'Save';

    const viewFeatures = (
      <Button
        variant="secondary"
        size="small"
        onClick={() => window.open('https://trevor.io/pricing', '_blank')}
      >
        View all features
      </Button>
    );

    return (
      <ModalContent
        showLoaderWithHeader={this.state.saving}
        small
        header="Change your plan"
        footer
        onSubmit={this.save}
        disabled={this.state.saving}
        disableCancel={this.state.saving}
        submitButtonText={saveText}
        onClose={closeModal}
        customControls={isPayingCustomer && <CancelLink navigate={navigate} />}
      >
        <div style={{ fontSize: '14px' }}>
          <p className={`${flex.row} ${flex.alignItemsCenter}`}>
            {isPayingCustomer ? (
              <span>Your current plan: {existingPlan.title}.&nbsp;</span>
            ) : null}
            {viewFeatures}
          </p>
          <div className="margin-top-20">{this.content()}</div>
        </div>
      </ModalContent>
    );
  }
}

export default ChangePlan;
